import React, { Component, useState } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Input, Divider } from 'antd';
import axios from '../../utils/request';

export class ZhongKeJin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isReady: false,
            username: "",
            tenantId: "",
            commonParamater: "",
            zhiwei: "测评",
            name: "",
            test: [],
            applicantId:""
        }
    };
    

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams);
        let commonParamater = urlParams.get("commonParamater");
        let tenantId = urlParams.get("tenantId");
        let applicantId = urlParams.get("applicantId");
        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.state.applicantId = applicantId;
        this.loadPage(tenantId, commonParamater, applicantId);
    };

    loadPage = (tenantId, commonParamater,applicantId) => {
        const params = {
            tenantId,
            commonParamater,
            applicantId
        }
        ///api/ZhongKeJin/ZKJ
        axios
            .get("/api/ZhongKeJin/GetEvaluationMessage", { params: params })
            .then(res => {
                console.log("中科金请求结果：", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {

                    console.log("中科金请求结果2：", res);
                    this.setState({ test: res.data.data, isLoading: false, isReady: true })
                    console.log(this.state.test);
                } else {
                    console.log("中科金请求结果3：", res);
                    errorMessage = "中科金请求错误！" + res.data.message;
                }

            })
            .catch(reason => {
                console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        if (this.state.isReady) {
            var items = [];
            for (var i = 0; i < this.state.test.length; i++) {
                var ac = this.state.test[i];
                items.push(
                    <div style={{ marginTop: "25px", width: "100%", border: "2px solid rgb(235, 237, 245)", borderRadius: "15px" }}>
                        <div style={{ padding: "20px 30px 0px 30px" }}>
                            <div>
                                <span style={{ color: "#fff", padding: "2px 7px 2px 7px", textAlign: "center", backgroundColor: "rgb(255, 146, 43)", borderRadius: "5px" }}>{this.state.zhiwei}</span>
                                <span style={{ marginLeft: "10px", fontSize: "20px", fontWeight: "bold" }}>{this.state.test[i].activityName}</span>
                            </div>
                            <div style={{ color: "rgb(194, 196, 209)", fontSize: "12px", marginTop: "10px" }}>{this.state.username}编号</div>
                            <Divider />
                        </div>
                        <div style={{ padding: "5px 30px 0px 30px", display: "table" }}>
                            <div style={{ display: "table-row" }}>
                                <span style={{ display: "table-cell", padding: "0 20px 0 0 ", color: "rgb(197, 200, 212)", fontSize: "14px" }}>详细成绩:{this.state.username}</span>
                                <span style={{ display: "table-cell" }}>
                                    <table>{
                                        this.state.test[i].ceyan.map((value) => {
                                            return (
                                                <tr>{value}</tr>
                                            )
                                        })
                                    }
                                    </table>
                                </span>
                            </div>
                        </div>
                        <div style={{ padding: "5px 30px 20px 30px", display: "table" }}>
                            <div style={{ display: "table-row" }}>
                                <span style={{ display: "table-cell", color: "rgb(197, 200, 212)", fontSize: "14px", padding: "10px 38px 0 0 ", marginTop: "10px" }}>报告：</span>
                                <span style={{ display: "table-cell" }}>
                                    <table>
                                        <tr></tr>
                                        {
                                            this.state.test[i].baogao.map((perso) => {
                                                return (
                                                    <tr><td>{perso.name}</td><td><a href={perso.url} style={{ marginLeft: "256px" }} target="_blank" rel="noreferrer">预览</a></td></tr>
                                                )
                                            })
                                        }
                                    </table>
                                </span>
                            </div>
                        </div>
                    </div >
                );
            }
            return (
                <div>
                { items }
            </div>
            );
        } else {
            return (
                <div style={{ textAlign: "center", padding: "15px", opacity: 1 }}>
                </div>
            );
        }
    }
}
